/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgAdd = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.389 2.595A6.5 6.5 0 018 1.5 6.507 6.507 0 0114.5 8 6.5 6.5 0 114.389 2.595zm4.108 4.902l3.939-.022.005 1-3.938.022.022 3.939-1 .005-.022-3.938-3.939.022-.006-1 3.94-.022-.023-3.939 1-.006.022 3.94z"
}));

export default SvgAdd;